import { render, staticRenderFns } from "./SyllabusTable.vue?vue&type=template&id=78dabe59&scoped=true&"
import script from "./SyllabusTable.vue?vue&type=script&lang=js&"
export * from "./SyllabusTable.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusTable.vue?vue&type=style&index=0&id=78dabe59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dabe59",
  null
  
)

export default component.exports